import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Client from './components/Client';
import ErrorTechnique from './components/ErrorTechnique';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import ErrorServiceId from './components/ErroServiceId';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

   <BrowserRouter>
      <Routes>
         <Route exact path="mnger/:idservice" element={< App />}></Route>
         <Route exact path="c/:folder" element={< Client />}></Route>
         <Route exact path="error" element={< ErrorTechnique />}></Route>
         <Route exact path="errorServiceId" element={< ErrorServiceId />}></Route>

      </Routes>
   </BrowserRouter>
); 
